module.exports = __webpack_public_path__ + "img/HeimwehScreenshot01.fe46a072.png";